import { Link } from "react-router-dom";
import { CategoryCard } from "../../../hooks/api/queries/useCategory";
import { SLUG_CATEGORY } from "../../../styles/slugs";
import { DesktopOnly } from "../../layout/nav/DesktopNavbar";
import { MobileOnly } from "../../layout/nav/Nav";
import { WImage } from "../../ui/image/Image";
import { appendCommitHash } from "../../../utils/appendHash";
import styled from "styled-components";
import { IMAGE_RATIOS } from "../../../styles/imageRatios";
import { breakpoint } from "../../../styles/constants";

type Props = {
  category: CategoryCard;
};

export const CollectionCard = ({ category }: Props) => (
  <Link to={appendCommitHash(`/${SLUG_CATEGORY}/${category.slug}`)}>
    <MobileOnly>
      <DivImage>
        <WImage
          image={category.imageMobile ?? category.defaultImageMobile}
          background
        />
      </DivImage>
    </MobileOnly>
    <DesktopOnly>
      <DivImage>
        <WImage
          image={category.imageDesktop ?? category.defaultImageDesktop}
          background
        />
      </DivImage>
    </DesktopOnly>
  </Link>
);

const DivImage = styled.div`
  img {
    object-fit: cover;
    aspect-ratio: ${IMAGE_RATIOS.CATEGORY_MOBILE};

    @media (min-width: ${breakpoint}) {
      aspect-ratio: ${IMAGE_RATIOS.CATEGORY};
    }
  }
`;
